import React from "react";
import { Select, MenuItem } from "@material-ui/core";
import { INumberDict } from "@src/Stores/Values/types";
import { STRoot, STInputLabel } from "./styles";

interface IProps {
  title: string;
  handleChange: React.EventHandler<any>;
  entities?: INumberDict;
  value?: string;
  defaultValue?: string;
}

const AuditLogFilter = (props: IProps) => {
  const { handleChange, entities, value, defaultValue, title } = props;
  return (
    <STRoot>
      <STInputLabel>{title}</STInputLabel>
      <Select value={value} onChange={handleChange}>
        <MenuItem key={defaultValue} value={defaultValue}>
          {defaultValue}
        </MenuItem>
        {Object.entries(entities || {}).map(key => (
          <MenuItem key={key[1]} value={key[1]}>
            {key[0]}
          </MenuItem>
        ))}
      </Select>
    </STRoot>
  );
};

export default AuditLogFilter;
